
import React from 'react';

export const ProcessSection: React.FC = () => {
  const steps = [
    {
      number: 1,
      title: 'Submit Property Details',
      description: 'Tell us about your multifamily property or commercial building. We need basic information to provide an accurate cash offer.'
    },
    {
      number: 2,
      title: 'Receive Cash Offer',
      description: 'Get your no-obligation cash offer within 24 hours. Our experienced team evaluates your property quickly and fairly.'
    },
    {
      number: 3,
      title: 'Close in 14 Days',
      description: 'Choose your closing date. We handle all paperwork and can close as fast as 14 days with cash in hand.'
    }
  ];

  return (
    <section id="how-it-works" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-block bg-orange-100 text-orange-600 px-4 py-2 rounded-full text-sm font-semibold mb-4">
            SIMPLE PROCESS
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            Three Steps to Selling Your <br />
            Apartments for Cash
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Our streamlined process makes selling your multifamily property fast and hassle-free
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 lg:gap-12">
          {steps.map((step, index) => (
            <div key={step.number} className="relative">
              <div className="bg-white rounded-2xl p-8 lg:p-12 shadow-lg hover:shadow-xl transition-shadow duration-300 text-center h-full">
                <div className="w-20 h-20 bg-orange-500 rounded-full flex items-center justify-center mx-auto mb-6">
                  <span className="text-3xl font-bold text-white">{step.number}</span>
                </div>
                
                <h3 className="text-2xl font-bold text-gray-900 mb-4">
                  {step.title}
                </h3>
                
                <p className="text-gray-600 leading-relaxed">
                  {step.description}
                </p>
              </div>
              
              {/* Arrow between steps */}
              {index < steps.length - 1 && (
                <div className="hidden md:block absolute top-1/2 -right-6 lg:-right-8 transform -translate-y-1/2 z-10">
                  <i className="ri-arrow-right-line text-orange-500 text-3xl"></i>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
